"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogCountLimiter = exports.Utils = void 0;
var logging_1 = require("@augloop/logging/dist/src/client/logging");
var Utils = /** @class */ (function () {
    function Utils() {
    }
    Utils.convertServiceUrlToWebSocket = function (serviceUrl) {
        var serviceUrlOnColon = serviceUrl.split(':');
        var serviceProtocol = serviceUrlOnColon[0].toLowerCase();
        if (serviceProtocol.indexOf('http') == 0) {
            serviceProtocol = serviceProtocol.replace('http', 'ws');
            serviceUrlOnColon[0] = serviceProtocol;
            return serviceUrlOnColon.join(':');
        }
        return serviceUrl;
    };
    /**
     * Gets current time, expressed in milliseconds since 00:00 UTC 1 Jan 1970.
     * Note that older versions of some browsers can produce NaN as result.
     */
    Utils.getCurrentTimeMs = function () {
        return Date.now ? Date.now() : new Date().getTime();
    };
    return Utils;
}());
exports.Utils = Utils;
var LogCountLimiter = /** @class */ (function () {
    function LogCountLimiter(id) {
        this.maxNumberOfLogs = 40;
        this.numberOfLogs = 0;
        this.id = id;
    }
    LogCountLimiter.prototype.log = function (logCode) {
        if (this.numberOfLogs < this.maxNumberOfLogs) {
            this.numberOfLogs++;
            logCode();
            if (this.numberOfLogs === this.maxNumberOfLogs) {
                var op = new logging_1.Operation({
                    operationName: 'OnLastLog',
                    success: true,
                    resourceId: this.id,
                    resultDescription: "Limit for number of logs for id: " + this.id + " reached - all next logs will be dropped",
                });
                logging_1.Log.warn(0x2224d0db /* tag_8jnd1 */, logging_1.LogCategory.CoreDefault, op);
            }
        }
    };
    return LogCountLimiter;
}());
exports.LogCountLimiter = LogCountLimiter;
//# sourceMappingURL=utils.js.map